import { useTranslations } from 'next-intl';

import { UiKitButtonBase } from '@/fo/ui/kit/button/base';
import { UiKitRatingBlock } from '@/fo/ui/kit/rating/block';
import { UiReviewTileProduct } from '@/fo/ui/review/tile/product';

import { Product, ReviewsData, ReviewsFilter, ReviewTab } from '../../types';
import { RatingFilter } from '../RatingFilter/RatingFilter';

import { styles } from './Sidebar.styles';

export interface SidebarProps {
  reviewsData: ReviewsData;
  product: Product;
  activeTab: ReviewTab;
  onActionClick?: (tab: ReviewTab) => void;
  filters: ReviewsFilter;
  onChangeFilters: (filters: ReviewsFilter) => void;
}

export function Sidebar({
  reviewsData,
  product,
  activeTab,
  onActionClick,
  filters,
  onChangeFilters
}: SidebarProps) {
  const t = useTranslations();

  const slots = styles();

  return (
    <div className={slots.base()}>
      <div className={slots.product()}>
        <UiReviewTileProduct
          title={product.title}
          shortDescription={product.shortDescription}
          tags={product.volume ? [product.volume] : []}
          imageUrl={product.imageUrl}
          url={product.url}
        />
      </div>
      <div className={slots.action()}>
        <UiKitButtonBase
          color="secondary"
          onClick={() => onActionClick?.(activeTab)}
          className={slots.actionButton()}
        >
          {t('review.buttons.leaveReview')}
        </UiKitButtonBase>
      </div>
      <UiKitRatingBlock
        value={reviewsData.rating}
        className={slots.rating()}
      />
      {reviewsData?.totalCount > 0 && (
        <span>
          {reviewsData?.totalCount}&nbsp;
          {t.rich('review.pluralizeItems', {
            count: reviewsData?.totalCount
          })}
        </span>
      )}
      <RatingFilter
        reviewsData={reviewsData}
        filters={filters}
        onChange={onChangeFilters}
      />
    </div>
  );
}
